
<!-- Детализация расчета -->

<template>

<elements
	v-if="init_done"
	ref="elements"
	:service="service"
	:attrs="attrs"
	essence_name_genetive_case="детализации"
	essence_name_for_plural_1="детализация"
	essence_name_for_plural_234="детализации"
	essence_name_for_plural_others="детализаций"
	without_add
	without_back_button
	not_able_for_delete
	without_details
	:postfix_for_storage_name="`details_expensive_${group_id}`"
	:additional_query="{ 'obj.group_id' : group_id, 'obj.type' : type }"
	:export_to_xlsx_extra="{ 'filter_value' : type }"
>

	<template v-slot:title><h4>Детализация</h4></template>

</elements>

</template>

<script>

import api from "../../../../../api"
import elements from "../../../../elements"

export default
{
	props :
	{
		group_id : String,
		type : String,
	},

	components :
	{
		elements,
	},

	data()
	{
		return {

			service : "cadastral_expensive_details",

			init_done : false,

			attrs : [],
    
		}
	},

	beforeMount()
	{
		this.attrs = []

		return api.call(this, "cadastral_expensive_details", "get_structure", {},
			response =>
			{
				for (const [ key, value ] of Object.entries(response.data) )
					if(key.includes("info") || key.includes("name"))
					{
						const type = ( key == "info.H" || key == "info.I" || key == "info.U" || key == "info.V" || key == "info.AO" || key == "info.B" || key == "info.AT" || key == "info.AU" || key == "info.AP" || key == "obj.name" ) ? "str" : "number"
						let label = value.replace("Информация / ", "").replace("Объект / ", "")
						let is_cadastral_number

						if(key == "info.AO") // Функциональная группа
							this.attrs.push(
								{
									key : key,
									label : label,
									type : type,
									sortable : true,
									visible : false,
									in_query : true,
									reference : { attr_key : "attrs.functional_group" },
								})
						else if(key == "info.B") // Функциональная подгруппа
							this.attrs.push(
								{
									key : key,
									label : label,
									type : type,
									sortable : true,
									visible : false,
									in_query : true,
									reference : { attr_key : "attrs.functional_sub_group" },
								})
						else
						{
							const visible = ( key == "info.C" || key == "info.AZ" || key == "info.BA" || key == "obj.name" ) // Площадь, УПКС, Кадастровая стоимость, КН
							const visible_if_no_visible = ( key == "info.C" || key == "info.AZ" || key == "info.BA" || key == "obj.name" ) // Площадь, УПКС, Кадастровая стоимость, КН
							var my_formatter = null

							if (key == "info.AZ" || key == "info.BA")
								my_formatter = elem => { return { value : api.format_cost(elem.value, "", "") } }
							else if(key == "obj.name")
								is_cadastral_number = true

							const desc =
								{
									key : key,
									label : label,
									type : type,
									sortable : true,
									visible : visible,
									visible_if_no_visible : visible_if_no_visible,
									is_cadastral_number : is_cadastral_number,
									in_query : true,
									my_formatter : my_formatter,
								}

							this.attrs.push(desc)
						}
					}

				this.init_done = true
			})
	},

	methods :
	{
		refresh()
		{
			this.$refs.elements.refresh()
		},
	}
}

</script>

